/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Academy_TitleInputs */

const en_academy_title = /** @type {(inputs: Academy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Academy`)
};

const ja_academy_title = /** @type {(inputs: Academy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカデミー`)
};

const fr_academy_title = /** @type {(inputs: Academy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Académie`)
};

const de_academy_title = /** @type {(inputs: Academy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akademie`)
};

/**
* | output |
* | --- |
* | "Academy" |
*
* @param {Academy_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const academy_title = /** @type {((inputs?: Academy_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Academy_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_academy_title(inputs)
	if (locale === "ja") return ja_academy_title(inputs)
	if (locale === "fr") return fr_academy_title(inputs)
	return de_academy_title(inputs)
});